import { useAppQuery } from "../../../http/useAppQuery.ts";
import type { DetailedComposition } from "../types.ts";

export const useComposition = (compositionUuid: string | null) => {
  const compositionQuery = useAppQuery<DetailedComposition>({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: `compositions/${compositionUuid!}`,
    enabled: !!compositionUuid,
    // XXX: In our standard workflow, we would invalidate this query whenever
    // we update the composition data, however that would trigger a reload
    // of the canvas objects which in turn would also trigger another update
    // of the composition data, thus creating an infinite get/update loop.
    // Therefore this query is never invalidated explicitly.
    // To avoid using un-fresh data coming from the query cache we use a staleTime of 0:
    // the data is never considered fresh and it will be refetched when required.
    staleTime: 0,
  });

  return {
    composition: compositionQuery.data,
    isLoading: compositionQuery.isLoading,
  };
};
